import { styled } from "@mui/material"
import List from "@mui/material/List"

export const StyledList = styled(List)`
  padding: 0.75rem 0.5rem 0.75rem 0;
`
